import { IShader } from './shaders/shader';
import { ShaderU01Siro } from './shaders/handles/shader_u_01_siro';
import { ShaderU02Alus } from './shaders/handles/shader_u_02_alus';
import { ShaderU03Schwinn } from './shaders/handles/shader_u_03_schwinn';
import { ShaderU04Schwinn } from './shaders/handles/shader_u_04_schwinn';
import { ShaderU05Schwinn } from './shaders/handles/shader_u_05_schwinn';
import { ShaderU06Siro } from './shaders/handles/shader_u_06_siro';
import { ShaderU07Schwinn } from './shaders/handles/shader_u_07_schwinn';
import { ShaderU08Schwinn } from './shaders/handles/shader_u_08_schwinn';
import { ShaderU09Siro } from './shaders/handles/shader_u_09_siro';
import { ShaderU10Schwinn } from './shaders/handles/shader_u_10_schwinn';
import { ShaderU11Schwinn } from './shaders/handles/shader_u_11_schwinn';
import { ShaderNull } from './shaders/shader_null';

export class Handle {
    constructor(
        public model: string,
        public light: string,
        public shader: IShader,
        public isLong: boolean,
        public avatar: string = shader.avatar,
    ) { }
}

export const handles = [
    new Handle(
        '',
        '',
        new ShaderNull(),
        false,
    ),
    new Handle(
        'u_01_siro.gltf',
        'u_01_siro_mesh_light.jpg',
        new ShaderU01Siro(),
        true,
    ),
    new Handle(
        'u_02_alus.gltf',
        'u_02_alus_mesh_light.jpg',
        new ShaderU02Alus(),
        false,
    ),
    new Handle(
        'u_03_schwinn.gltf',
        'u_03_schwinn_mesh_light.jpg',
        new ShaderU03Schwinn(),
        false,
    ),
    new Handle(
        'u_04_schwinn.gltf',
        'u_04_schwinn_mesh_light.jpg',
        new ShaderU04Schwinn(),
        false,
    ),
    new Handle(
        'u_05_schwinn.gltf',
        'u_05_schwinn_mesh_light.jpg',
        new ShaderU05Schwinn(),
        false,
    ),
    new Handle(
        'u_06_siro.gltf',
        'u_06_siro_mesh_light.jpg',
        new ShaderU06Siro(),
        false,
    ),
    new Handle(
        'u_07_schwinn.gltf',
        'u_07_schwinn_mesh_light.jpg',
        new ShaderU07Schwinn(),
        false,
    ),
    new Handle(
        'u_08_schwinn.gltf',
        'u_08_schwinn_mesh_light.jpg',
        new ShaderU08Schwinn(),
        true,
    ),
    new Handle(
        'u_09_siro.gltf',
        'u_09_siro_mesh_light.jpg',
        new ShaderU09Siro(),
        true,
    ),
    new Handle(
        'u_10_schwinn.gltf',
        'u_10_schwinn_mesh_light.jpg',
        new ShaderU10Schwinn(),
        true,
    ),
    new Handle(
        'u_11_schwinn.gltf',
        'u_11_schwinn_mesh_light.jpg',
        new ShaderU11Schwinn(),
        true,
    ),
];
